import http from '../../services/http-common';


// ✅ Add these imports (Syncfusion PDF)
import {
  PdfDocument, PdfPageSize,PdfBrushes,
  PdfStandardFont, PdfFontFamily, PdfFontStyle,
  gridpdf, PdfPen, PdfColor, PdfSolidBrush,
  PdfStringFormat, PdfTextAlignment, PdfVerticalAlignment,
  PdfBitmap,
  PdfGrid
} from "@syncfusion/ej2-pdf-export";
import { PdfPageOrientation } from "@syncfusion/ej2-pdf-export";

import moment from 'moment';
class InvoiceService {

  getForList(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/Invoice/list?${queryParams}`);
  }

  getInvoiceDetail(data) {
        let queryParams = new URLSearchParams(data).toString();

    return http.get(`/Invoice/InvoiceDetail?${queryParams}`);
  }

  getNextInvoiceID(InvoiceType = 'SS') {
    return http.get(`/Invoice/NextInvoiceID?InvoiceType=${InvoiceType}`);
  }

  // Dropdown sources (optional)
  getBuyerDDSource() {
    return http.get(`/Invoice/BuyerDDSource`);
  }
  getHSCodeDDSource() {
    return http.get(`/Invoice/HSCodeDDSource`);
  }
  getUnitOfMeasurementDDSource() {
    return http.get(`/Invoice/UnitOfMeasurementDDSource`);
  }

  addRecords(data) {
    return http.post(`/Invoice/add`, data);
  }

  updateMainData(data) {
    return http.put(`/Invoice/update`, data);
  }

  updateDetailData(data) {
    return http.put(`/Invoice/update-detail`, data);
  }

  
// =========================
// REPORT (Preview / PDF)
// =========================

toNum(v) {
  const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
  return isNaN(n) ? 0 : n;
}



async generateInvoiceReportPDF(mainRow, detailRows, blob) {
  const doc = new PdfDocument();
  doc.pageSettings.size = PdfPageSize.a4;
  doc.pageSettings.orientation = PdfPageOrientation.Portrait;
  doc.pageSettings.margins.all = 8;

  const page = doc.pages.add();
  const g = page.graphics;

  const black = new PdfSolidBrush(new PdfColor(0, 0, 0));
  const linePen = new PdfPen(new PdfColor(0, 0, 0), 1);
  const outerPen = new PdfPen(new PdfColor(0, 0, 0), 1.2);

  const fontTitle = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
  const fontBold = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
  const font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

  const pageW = page.getClientSize().width;

  const x0 = 8;
  const xR = pageW - 8;
  const usableW = xR - x0;

  const txt = (v) => {
    const s = String(v ?? "").trim();
    return s ? s : "";
  };

  const toNum = (v) => {
    const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };

  const textW = (fnt, s) => {
    try {
      return fnt.measureString(String(s)).width || 0;
    } catch {
      return String(s).length * 5;
    }
  };

  const drawField = (caption, value, capX, y, lineEndX) => {
    const capText = `${(caption || '').toUpperCase()} :`;
    g.drawString(capText, fontBold, null, black, capX, y);
    const startX = capX + textW(fontBold, capText) + 6;
    g.drawLine(linePen, startX, y + 11, lineEndX, y + 11);
    g.drawString(txt(String(value || '').toUpperCase()), font, null, black, startX + 2, y);
  };

  // =========================
  // CHANGE 7: FBR Logo (top-left) + QR Code (top-right)
  // =========================
  const blobToBase64 = (b) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(b);
    });
  };

  const logoSize = 60;
  let y = 10;

  // FBR Logo - top left
  try {
    const FBRIMGresponse = await fetch('/fbr-img.jpg');
    if (FBRIMGresponse.ok) {
      const FBRimageBlob = await FBRIMGresponse.blob();
      const FBRimageBase64 = await blobToBase64(FBRimageBlob);
      const FBRimage = new PdfBitmap(FBRimageBase64);
      g.drawImage(FBRimage, x0, y, logoSize, logoSize);
    }
  } catch (e) { console.warn("FBR logo load failed", e); }

  // QR Code - top right (blob passed as parameter)
  try {
    if (blob) {
      const url = URL.createObjectURL(blob);
      const response = await fetch(url);
      if (response.ok) {
        const imageBlob = await response.blob();
        const imageBase64 = await blobToBase64(imageBlob);
        const qrImage = new PdfBitmap(imageBase64);
        g.drawImage(qrImage, pageW - logoSize - x0, y+5, logoSize + 20, logoSize + 20);
        URL.revokeObjectURL(url);
      }
    }
  } catch (e) { console.warn("QR code load failed", e); }

  // =========================
  // HEADER (Company info centered, logos on sides)
  // =========================
  const companyName = txt((mainRow?.sellerBusinessName || '').toUpperCase());
  const sellerNTN = txt((mainRow?.sellerNTNCNIC || '').toUpperCase());
  const sellerAddress = txt((mainRow?.sellerAddress || '').toUpperCase());

  // Company Name (center)
  const fontCompany = new PdfStandardFont(PdfFontFamily.Helvetica, 18, PdfFontStyle.Bold);
  const wCompany = fontCompany.measureString(companyName).width;
  g.drawString(companyName, fontCompany, null, black, (pageW - wCompany) / 2, y);
  y += 22;

  // NTN (center)
  const ntnLine = (`NTN: ${sellerNTN}`).toUpperCase();
  const fontNTN = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
  const wNTN = fontNTN.measureString(ntnLine).width;
  g.drawString(ntnLine, fontNTN, null, black, (pageW - wNTN) / 2, y);
  y += 20;

  // Address (center)
  const fontAddress = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
  const wAddr = fontAddress.measureString(sellerAddress).width;
  g.drawString(sellerAddress, fontAddress, null, black, (pageW - wAddr) / 2, y);
  y += 18;

  // Invoice heading (center)
  const invoiceTitle = mainRow?.InvoiceType == "SS" ? "SALE INVOICE" : "PURCHASE INVOICE";
  const wInv = fontTitle.measureString(invoiceTitle).width;
  g.drawString(invoiceTitle, fontTitle, null, black, (pageW - wInv) / 2, y);
  y += 28;

  // =========================
  // CHANGE 4: Invoice No | Date | Reference No. (ChallanNo) — ONE ROW
  // =========================
  const invoiceNo = txt(mainRow?.InvoiceID);
  const invDate = mainRow?.InvoiceDate
    ? moment(mainRow.InvoiceDate).format("DD-MMM-YYYY")
    : "";
  const challanNo = txt(mainRow?.ChallanNo);

  // 3 fields in one row: Invoice No (0-33%), Date (33-66%), Reference No. (66-100%)
  const col3W = Math.floor(usableW / 3);
  drawField("Invoice No",    invoiceNo,  x0,                   y, x0 + col3W - 8);
  drawField("Date",          invDate,    x0 + col3W,           y, x0 + col3W * 2 - 8);
  drawField("Reference No.", challanNo,  x0 + col3W * 2,       y, xR);
  y += 25;

  // =========================
  // CHANGE 5: Buyer + FBRSaleInvoiceNo in ONE ROW
  // =========================
  let captionCondition = mainRow?.InvoiceType == "SS" ? "Buyer's Name" : "Seller Name";
  const buyerEndX = x0 + Math.floor(usableW * 0.55);
  drawField(captionCondition,     (mainRow?.buyerBusinessName || mainRow?.BuyerNTNCNIC), x0,        y, buyerEndX);
  drawField("FBR Invoice No.",    mainRow?.FBRSaleInvoiceNo,                             buyerEndX + 4, y, xR);
  y += 25;

  // Address
  drawField("Address", mainRow?.buyerAddress, x0, y, xR);
  y += 25;

  // Phone + Sales Tax + NTN (3 fields, no overlap)
  const phoneCapX    = x0;
  const salesTaxCapX = x0 + Math.floor(usableW * 0.34);
  const ntnCapX      = x0 + Math.floor(usableW * 0.68);

  drawField("Phone #",          mainRow?.buyerContactNumber, phoneCapX,    y, salesTaxCapX - 12);
  drawField("Sales Tax Regn #", mainRow?.buyerSTRN,          salesTaxCapX, y, ntnCapX - 12);
  drawField("N.T.N #",          mainRow?.BuyerNTNCNIC,        ntnCapX,      y, xR);
  y += 25;

  // =========================
  // CHANGE 6: REMARKS — full row, below NTN
  // =========================
  drawField("Remarks", mainRow?.Remarks, x0, y, xR);
  y += 25;

  // =========================
  // CHANGE 1 & 2: TABLE — Remove FBR QTY/UNIT, Add HSCODE after UNIT
  // New columns: QUANTITY | UNIT | HSCODE | DESCRIPTION | UNIT PRICE | VALUE | TAX RATE | TAX AMT | TOTAL
  // =========================
  const clientW  = page.getClientSize().width;
  const tableX   = 0;
  const tableW   = clientW;
  const grid     = new PdfGrid();
  grid.columns.add(9);   // 9 columns now

  if (!grid.style) grid.style = {};
  grid.style.cellPadding = { left: 2, right: 3, top: 3, bottom: 3 };
  grid.style.font = font;

  const colP = (p) => tableW * p;

  const cQty   = colP(0.08);  // QUANTITY
  const cUnit  = colP(0.08);  // UNIT
  const cHS    = colP(0.09);  // HSCODE  ← NEW
  const cDesc  = colP(0.22);  // DESCRIPTION
  const cUP    = colP(0.10);  // UNIT PRICE
  const cVal   = colP(0.10);  // VALUE
  const cTR    = colP(0.09);  // TAX RATE
  const cTA    = colP(0.10);  // TAX AMT
  const cTot   = Math.floor(tableW - (cQty + cUnit + cHS + cDesc + cUP + cVal + cTR + cTA)); // TOTAL (remainder)

  grid.columns.getColumn(0).width = cQty;
  grid.columns.getColumn(1).width = cUnit;
  grid.columns.getColumn(2).width = cHS;
  grid.columns.getColumn(3).width = cDesc;
  grid.columns.getColumn(4).width = cUP;
  grid.columns.getColumn(5).width = cVal;
  grid.columns.getColumn(6).width = cTR;
  grid.columns.getColumn(7).width = cTA;
  grid.columns.getColumn(8).width = cTot;

  // Header row
  const header    = grid.headers.add(1)[0];
  const headerFmt = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

  const headers = [
    "QUANTITY",
    "UNIT",
    "HS CODE",
    "DESCRIPTION OF GOODS",
    "UNIT\nPRICE",
    "VALUE OF\nGOODS",
    "RATE OF\nSALES\nTAX",
    "VALUE\nOF SALES\nTAX",
    "TOTAL VALUE"
  ];

  headers.forEach((h, i) => {
    header.cells.getCell(i).value = h;
    header.cells.getCell(i).style.font = fontBold;
    header.cells.getCell(i).style.stringFormat = headerFmt;
  });

  // Data rows
  let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0;

  (detailRows || []).forEach((r) => {
    const qty    = toNum(r?.Quantity);
    const rate   = toNum(r?.Rate);
    const bill   = toNum(r?.BillAmount) || (qty * rate);
    const taxPer = toNum(r?.TaxPercent);
    const taxAmt = toNum(r?.TaxAmount)  || (bill * (taxPer / 100));
    const total  = toNum(r?.TotalAmount) || (bill + taxAmt);

    sumQty   += qty;
    sumValue += bill;
    sumTax   += taxAmt;
    sumTotal += total;

    const row = grid.rows.addRow();

    row.cells.getCell(0).value = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
    row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);

    row.cells.getCell(1).value = r?.UnitOfMeasurement || "";
    row.cells.getCell(1).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    // CHANGE 2: HSCODE
    row.cells.getCell(2).value = txt(r?.hS_CODE || "");
    row.cells.getCell(2).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    row.cells.getCell(3).value = txt((r?.ProductDescription || '').toUpperCase());
    row.cells.getCell(3).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

    row.cells.getCell(4).value = rate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(5).value = bill.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(6).value = taxPer.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(7).value = taxAmt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    row.cells.getCell(8).value = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    [0, 4, 5, 6, 7, 8].forEach((c) => {
      row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
    });
  });

  // Total row
  const tr = grid.rows.addRow();
  tr.cells.getCell(0).value = sumQty ? sumQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
  tr.cells.getCell(1).value = "";
  tr.cells.getCell(2).value = "";
  tr.cells.getCell(3).value = "";
  tr.cells.getCell(4).value = "";
  tr.cells.getCell(5).value = sumValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  tr.cells.getCell(6).value = "";
  tr.cells.getCell(7).value = sumTax.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  tr.cells.getCell(8).value = sumTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  for (let i = 0; i < tr.cells.count; i++) {
    tr.cells.getCell(i).style.font = fontBold;
    tr.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  }

  y += 22;
  const result = grid.draw(page, { x: tableX, y });

  // =========================
  // CHANGE 3: SIGNATURE — Only PREPARED BY and RECEIVED BY (APPROVED BY removed)
  // =========================
  const signY    = result.bounds.y + result.bounds.height + 90;
  const lineW    = 120;
  const signFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Regular);
  const signPen  = new PdfPen(new PdfColor(0, 0, 0), 1);

  const leftX  = tableX + 50;
  const rightX = tableX + tableW - lineW - 50;

  const drawSign = (label, x) => {
    g.drawLine(signPen, x, signY, x + lineW, signY);
    const w = signFont.measureString(label).width;
    g.drawString(label, signFont, null, black, x + (lineW - w) / 2, signY + 6);
  };

  drawSign("PREPARED BY", leftX);
  drawSign("RECEIVED BY", rightX);

  // Outer border
  g.drawRectangle(outerPen, result.bounds.x, result.bounds.y, result.bounds.width, result.bounds.height);

  // Save
  let fileName = mainRow?.InvoiceType == "SS" ? 'SALE' : 'PURCHASE';
  const file = `INV_${fileName}_${invoiceNo}.pdf`;
  doc.save(file);
  doc.destroy();
  return null;
}



// PREVIEW D 
wrapText(graphics, text, font, brush, x, y, maxWidth, lineHeight) {
    const words = String(text ?? "").split(" ");
    let line = "";
    let yOffset = y;
  
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = font.measureString(testLine).width;
  
      if (testWidth > maxWidth && i > 0) {
        graphics.drawString(line.trim(), font, null, brush, x, yOffset);
        line = words[i] + " ";
        yOffset += lineHeight;
      } else {
        line = testLine;
      }
    }
  
    if (line) {
      graphics.drawString(line.trim(), font, null, brush, x, yOffset);
    }
  
    // IMPORTANT: return last drawn Y so caller can continue below it
    return yOffset;
  }








  //  ==== CALL SALE INVOICE REPORT SERVICES ======

       convertNumberToWords(num) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function numberToWords(n) {
    if (n === 0) return "Zero";
    if (n < 20) return units[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");

    for (let scale of scales) {
      if (n >= scale.value) {
        const quotient = Math.floor(n / scale.value);
        const remainder = n % scale.value;
        return (
          numberToWords(quotient) +
          " " +
          scale.name +
          (remainder ? " " + numberToWords(remainder) : "")
        );
      }
    }
    return "";
  }

  const whole = Math.floor(num);
  const fraction = Math.round((num - whole) * 100);

  let result = numberToWords(whole) + " Rupees";
  result += " and " + numberToWords(fraction) + " Paise";

  return result;
}


async generateInvoiceReportPDFD(mainRow, detailRows, blob) {
  console.log(mainRow)
     const document = new PdfDocument();
    
      // Page settings
      document.pageSettings.margins.all = 10;
      document.pageSettings.margins.bottom = 5;
      document.pageSettings.size = PdfPageSize.a4;
    
      // Add page
      const page = document.pages.add();
      const graphics = page.graphics;
     const gridpdf     = new PdfGrid();
      // Fonts & brushes
      const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 16, PdfFontStyle.Bold);
      const subFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
      const subBoldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8, PdfFontStyle.Bold);
      const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
      const boldFonts = new PdfStandardFont(PdfFontFamily.Helvetica, 10, PdfFontStyle.Bold);
      
      const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
      const pageWidth = page.getClientSize().width;
  
  const fontTitle = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
    const fontBold = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    const font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);
    const txt = (v) => {
      const s = String(v ?? "").trim();
      return s ? s : "";
    };
  
    const toNum = (v) => {
      const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
      return isNaN(n) ? 0 : n;
    };
  
  
  
  
      
   // MAIN SECTION START
   
      graphics.drawString("Sale Invoice", headerFont, null, blackBrush, 220, 30);
  
      graphics.drawString("SOFTWARE  ID:", boldFont, null, blackBrush, 350, 80);
      graphics.drawString(`${String(mainRow?.InvoiceID ?? '').padStart(4, '0')}`, subFont, null, blackBrush, 440, 81);
      graphics.drawString("DATE:", boldFont, null, blackBrush, 350, 95);
      graphics.drawString(`${moment(mainRow.InvoiceDate).format("DD-MMM-YY")}`, subFont, null, blackBrush, 440, 96);
    
     
  
      // ---------- helpers ----------
  // const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";
  
  const lineH10 = 10;     // for wrap text
  const rowGap = 15;      // standard row vertical gap
   let y = 10;
  const buyerX = 10;
  const sellerX = 350;
  
  const buyerLabelX = buyerX;
  const sellerLabelX = sellerX;
  
  // fixed indent so values align nicely
  const buyerValueX = buyerX + 90;
  const sellerValueX = sellerX + 90;
  
  // available widths for wrapped values
  const buyerValueWidth = 280 - 90; // block width ~280, minus indent
  const sellerValueWidth = 200 - 90; // block width ~200, minus indent
  
  const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== "";
  
  const drawOptionalRowPair = (y, caption, buyerVal, sellerVal) => {
    // Row show ONLY if either side has value
    if (!hasValue(buyerVal) && !hasValue(sellerVal)) return y;
  
    // captions on BOTH sides
    graphics.drawString(`${caption}:`, boldFont, null, blackBrush, buyerLabelX, y);
    graphics.drawString(`${caption}:`, boldFont, null, blackBrush, sellerLabelX, y);
  
    // values (only where present)
    const buyerEndY = hasValue(buyerVal)
      ? this.wrapText(graphics, String(buyerVal), subFont, blackBrush, buyerValueX, y + 1, buyerValueWidth, lineH10)
      : y;
  
    const sellerEndY = hasValue(sellerVal)
      ? this.wrapText(graphics, String(sellerVal), subFont, blackBrush, sellerValueX, y + 1, sellerValueWidth, lineH10)
      : y;
  
    // next row starts after the longer (wrapped) side
    return Math.max(buyerEndY, sellerEndY) + rowGap;
  };
  
  // ---------- Reference No. above INVOICE ----------
  let leftTopY = 80; // above your INVOICE line at y=35
  if (hasValue(mainRow?.InvoiceReferenceNo)) {
    graphics.drawString("REFERENCE NO.:", boldFont, null, blackBrush, buyerLabelX, leftTopY);
    this.wrapText(
      graphics,
      String(mainRow.InvoiceReferenceNo || '').toUpperCase(),
      subFont,
      blackBrush,
      buyerLabelX + 90,
      leftTopY + 1,
      buyerValueWidth,
      lineH10
    );
  }
  
  // ---------- INVOICE (same as before) ----------
  graphics.drawString("FBR INVOICE NO.:", boldFont, null, blackBrush, 10, 95);
  graphics.drawString(`${String(mainRow?.FBRSaleInvoiceNo ?? "").toUpperCase()}`, subFont, null, blackBrush, 100, 96);
  
  // ---------- BUYER block ----------
  graphics.drawString("BUYER:", boldFont, null, blackBrush, buyerLabelX, 120);
  
  let buyerY = 135;
  buyerY = this.wrapText(
    graphics,
    String(mainRow?.buyerBusinessName ?? "").toUpperCase(),
    // subFont,
    subBoldFont,
    blackBrush,
    buyerLabelX,
    buyerY,
    280,
    lineH10
  ) + lineH10;
  
  buyerY = this.wrapText(
    graphics,
    String(mainRow?.buyerAddress ?? "").toUpperCase(),
    subFont,
    blackBrush,
    buyerLabelX,
    buyerY,
    270,
    lineH10
  ) + rowGap;
  
  
  // ---------- SELLER block ----------
  graphics.drawString("SELLER:", boldFont, null, blackBrush, sellerLabelX, 120);
  
  let sellerY = 135;
  sellerY = this.wrapText(
    graphics,
    String(mainRow?.sellerBusinessName ?? "").toUpperCase(),
    // subFont,
    subBoldFont,
    blackBrush,
    sellerLabelX,
    sellerY,
    200,
    lineH10
  ) + lineH10;
  
  sellerY = this.wrapText(
    graphics,
    String(mainRow?.sellerAddress ?? "").toUpperCase(),
    subFont,
    blackBrush,
    sellerLabelX,
    sellerY,
    200,
    lineH10
  ) + rowGap;
  
  
  let commonY = Math.max(buyerY, sellerY);
  buyerY = sellerY = commonY;
  
  // Optional rows (row-level OR)
  commonY = drawOptionalRowPair(
    commonY,
    "CONTACT PERSON",
    mainRow?.buyerContactPerson || '',
    mainRow?.sellerContactPerson || 'T'
  );
  
  commonY = drawOptionalRowPair(
    commonY,
    "CONTACT NO.",
    mainRow?.buyerContactNumber || '',
    mainRow?.sellerContactNumber || ''
  );
  
  commonY = drawOptionalRowPair(
    commonY,
    "STRN",
    mainRow?.buyerSTRN || '',
    mainRow?.sellerSTRN || ''
  );
  
  commonY = drawOptionalRowPair(
    commonY,
    "CNIC NO.",
    mainRow?.buyerCNIC,
    mainRow?.sellerCNIC
  );
  
  buyerY = sellerY = commonY; // keep both aligned for REGION/NTN/TYPE etc
  
  // BUYER mandatory rows
  graphics.drawString("REGION:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(mainRow?.buyerProvinceName ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  graphics.drawString("NTN:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(mainRow?.BuyerNTNCNIC ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  graphics.drawString("TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(!mainRow?.buyerRegistrationType  || mainRow?.buyerRegistrationType  == 'null' ?  "" : mainRow?.buyerRegistrationType ?? '').toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  graphics.drawString("SALE TYPE:", boldFont, null, blackBrush, buyerLabelX, buyerY);
  graphics.drawString(String(mainRow?.transactioN_Desc ?? "").toUpperCase(), subFont, null, blackBrush, buyerValueX, buyerY + 1);
  buyerY += rowGap;
  
  // SELLER mandatory rows
  graphics.drawString("REGION:", boldFont, null, blackBrush, sellerLabelX, sellerY);
  graphics.drawString(String(mainRow?.SellerProvinceName ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
  sellerY += rowGap;
  
  graphics.drawString("NTN:", boldFont, null, blackBrush, sellerLabelX, sellerY);
  // graphics.drawString(String(mainRow?.sellerNTN ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
  graphics.drawString(String(
    mainRow?.sellerNTNCNICReferenceNo &&
    mainRow?.sellerNTNCNICReferenceNo.length >= 7
      ? mainRow.sellerNTNCNIC
      : mainRow?.sellerNTNCNIC ?? "").toUpperCase(), subFont, null, blackBrush, sellerValueX, sellerY + 1);
  sellerY += rowGap;
  
  graphics.drawString("TYPE:", boldFont, null, blackBrush, sellerLabelX, sellerY);
  graphics.drawString("REGISTERED", subFont, null, blackBrush, sellerValueX, sellerY + 1);
  sellerY += rowGap;
  
  // ---------- Use this to place table automatically below header blocks ----------
  const tableStartY = Math.max(180, Math.max(buyerY, sellerY) + 5);
      // MAIN  SECTION  END
  
  
  
  
  
  
  
  
  
  
    // =========================
    // CHANGE 1 & 2: TABLE — Remove FBR QTY/UNIT, Add HSCODE after UNIT
    // New columns: QUANTITY | UNIT | HSCODE | DESCRIPTION | UNIT PRICE | VALUE | TAX RATE | TAX AMT | TOTAL
    // =========================
   
    const clientW  = page.getClientSize().width;
    const tableX   = 0;
    const tableW   = clientW;
    gridpdf.columns.add(9);   // 9 columns now
  
    if (!gridpdf.style) gridpdf.style = {};
    gridpdf.style.cellPadding = { left: 2, right: 3, top: 3, bottom: 3 };
    gridpdf.style.font = font;
  
    const colP = (p) => tableW * p;
  
    const cQty   = colP(0.08);  // QUANTITY
    const cUnit  = colP(0.08);  // UNIT
    const cHS    = colP(0.09);  // HSCODE  ← NEW
    const cDesc  = colP(0.22);  // DESCRIPTION
    const cUP    = colP(0.10);  // UNIT PRICE
    const cVal   = colP(0.10);  // VALUE
    const cTR    = colP(0.09);  // TAX RATE
    const cTA    = colP(0.10);  // TAX AMT
    const cTot   = Math.floor(tableW - (cQty + cUnit + cHS + cDesc + cUP + cVal + cTR + cTA)); // TOTAL (remainder)
  
    gridpdf.columns.getColumn(0).width = cQty;
    gridpdf.columns.getColumn(1).width = cUnit;
    gridpdf.columns.getColumn(2).width = cHS;
    gridpdf.columns.getColumn(3).width = cDesc;
    gridpdf.columns.getColumn(4).width = cUP;
    gridpdf.columns.getColumn(5).width = cVal;
    gridpdf.columns.getColumn(6).width = cTR;
    gridpdf.columns.getColumn(7).width = cTA;
    gridpdf.columns.getColumn(8).width = cTot;
  
    // Header row
    const header    = gridpdf.headers.add(1)[0];
    const headerFmt = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);
  
    const headers = [
      "QUANTITY",
      "UNIT",
      "HS CODE",
      "DESCRIPTION OF GOODS",
      "UNIT\nPRICE",
      "VALUE OF\nGOODS",
      "RATE OF\nSALES\nTAX",
      "VALUE\nOF SALES\nTAX",
      "TOTAL VALUE"
    ];
  
    // headers.forEach((h, i) => {
    //   header.cells.getCell(i).value = h;
    //   header.cells.getCell(i).style.font = fontBold;
    //   header.cells.getCell(i).style.stringFormat = headerFmt;
    // });
  
    
  const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
  
  const styleHeaderCell = (cell) => {
    cell.style.font = headersboldFont;
    cell.style.stringFormat = headerFmt;
    cell.style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 150, 100)); // teal blue
    cell.style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));     // white text
  };
  headers.forEach((col, i) => {
    const cell = header.cells.getCell(i);
    cell.value = col;
    styleHeaderCell(cell);
  });
  
  
    // Data rows
    let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0;
  
    (detailRows || []).forEach((r) => {
      const qty    = toNum(r?.Quantity);
      const rate   = toNum(r?.Rate);
      const bill   = toNum(r?.BillAmount) || (qty * rate);
      const taxPer = toNum(r?.TaxPercent);
      const taxAmt = toNum(r?.TaxAmount)  || (bill * (taxPer / 100));
      const total  = toNum(r?.TotalAmount) || (bill + taxAmt);
  
      sumQty   += qty;
      sumValue += bill;
      sumTax   += taxAmt;
      sumTotal += total;
  
      const row = gridpdf.rows.addRow();
  
      row.cells.getCell(0).value = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
      row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  
      row.cells.getCell(1).value = r?.UnitOfMeasurement || "";
      row.cells.getCell(1).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);
  
      // CHANGE 2: HSCODE
      row.cells.getCell(2).value = txt(r?.hS_CODE || "");
      row.cells.getCell(2).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);
  
      row.cells.getCell(3).value = txt((r?.ProductDescription || '').toUpperCase());
      row.cells.getCell(3).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);
  
      row.cells.getCell(4).value = rate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(5).value = bill.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(6).value = taxPer.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(7).value = taxAmt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(8).value = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
      [0, 4, 5, 6, 7, 8].forEach((c) => {
        row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
      });
    });
  
    // // Total row
    // const tr = gridpdf.rows.addRow();
    // tr.cells.getCell(0).value = sumQty ? sumQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
    // tr.cells.getCell(1).value = "";
    // tr.cells.getCell(2).value = "";
    // tr.cells.getCell(3).value = "";
    // tr.cells.getCell(4).value = "";
    // tr.cells.getCell(5).value = sumValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // tr.cells.getCell(6).value = "";
    // tr.cells.getCell(7).value = sumTax.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // tr.cells.getCell(8).value = sumTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
    // for (let i = 0; i < tr.cells.count; i++) {
    //   tr.cells.getCell(i).style.font = fontBold;
    //   tr.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
    // }
  
    y += 22;
    // const result = gridpdf.draw(page, { x: tableX, y });
  
  
  
  // IMAGE FOOTER COMPLETED
  const layoutResult = gridpdf.draw(page, { x: tableX, y: tableStartY });
  
      console.log(sumTotal)
      let TotalAmountSum = this.convertNumberToWords(sumTotal.toFixed(2)) + " Only"
      console.log(TotalAmountSum)
      let yBase = layoutResult.bounds.y + layoutResult.bounds.height + 25;
  
      graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
      this.wrapText(
        graphics,
        String(TotalAmountSum),
        boldFont,
        blackBrush,
        10,
        yBase + 15,
        300,
        15
      );
  
  
  // rectangle box start
  
  
      let xPos = page.getClientSize().width - 250;  // right aligned box
  let yPos = layoutResult.bounds.height + layoutResult.bounds.y + 20; 
  let boxWidth = 220;
  let boxHeight = 80;
  
  graphics.drawRectangle(new PdfPen(PdfColor.black, 1), xPos, yPos, boxWidth, boxHeight);
  
  let lineHeight = 14;
  let padding = 5;
  
  // Function to measure and right-align text
  function drawRightAligned(text, yOffset, font) {
      let textWidth = font.measureString(text).width;
      let drawX = xPos + boxWidth - padding - textWidth; // right edge inside box
      let drawY = yPos + yOffset;
      graphics.drawString(text, font, null, PdfBrushes.black, drawX, drawY);
  }
  drawRightAligned(`QUANTITY: ${(sumQty || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
  drawRightAligned(`VALUE OF GOODS: ${(sumValue || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
  drawRightAligned(`VALUE OF SALES TAX: ${(sumTax || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
  drawRightAligned(
    `Grand Total Value : Rs. ${(sumTotal || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    6 + lineHeight * 4,
    boldFont
  );
  // rectangle box end
  
  
  
      //  // ===== IMAGE (Base64 PNG) =====
      const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
      };
    
    
        const url = URL.createObjectURL(blob);
  
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
      
        const imageBlob = await response.blob();
        const imageBase64 = await blobToBase64(imageBlob);
      
       // Create PdfBitmap from Base64
       const image = new PdfBitmap(imageBase64);
         
       // Draw the image on the PDF
       let xImgPos = page.getClientSize().width - 115;  // right aligned box
        let yImgPos = layoutResult.bounds.height + layoutResult.bounds.y + 140; 
       graphics.drawImage(image, xImgPos, yImgPos,96 ,96 ); // Adjust x, y, width, height as needed
        
  
  
       // ==== FBR IMAGE DRAW ====
       const FBRIMGresponse = await fetch('/fbr-img.jpg');
       if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
       
               const FBRimageBlob = await FBRIMGresponse.blob();
               const FBRimageBase64 = await blobToBase64(FBRimageBlob);
       
              // Create PdfBitmap from Base64
              const FBRimage = new PdfBitmap(FBRimageBase64);
                
              // Draw the FBRimage on the PDF
              graphics.drawImage(FBRimage, 40, yImgPos,50 ,50 ); // Adjust x, y, width, height as needed
              graphics.drawString(
                " THIS IS A SYSTEM GENERATED DIGITAL INVOICE. NO SIGNATURE REQUIRED",
                subFont,
                null,
                blackBrush,
                pageWidth / 2 - 150,
                yImgPos + 150
              );
              graphics.drawString(
              mainRow?.Remarks,
              boldFonts,
                null,
                blackBrush,
                pageWidth / 2 -40,
                yImgPos + 170
              );
              
  
      let partyName = (mainRow?.buyerBusinessName || '')
    .toUpperCase()
    .split(/\s+/)[0]; 
  
        document.save(`INV_D_${partyName}_${mainRow?.InvoiceID}.pdf`);
        document.destroy();
  }
  
}




export default new InvoiceService();

